module.exports = "pages:\n- Hello, world!: ./tutorial/tutorial1.md\n- Simple CRUD(1): ./tutorial/tutorial2.md\n- Simple CRUD(2): ./tutorial/tutorial3.md"